import PageHeader from "./page-header.vue";
export default {
  install(Vue) {
    Vue.component(PageHeader.name, PageHeader);
  }
}